/**
 * TanStack Router: /performance/feedbacks/received
 *
 * This route file was created for the employee feedback received view.
 * Component: ReceivedFeedbacksPage
 * Layout: Authenticated (_auth)
 *
 * @see packages/web-apps/monutrack/src/app/performance/feedbacks/received/page.tsx
 */
import { createFileRoute } from '@tanstack/react-router'
import ReceivedFeedbacksPage from '@/app/performance/feedbacks/received/page'

/**
 * Route: /performance/feedbacks/received
 * Layout: _auth (authenticated)
 * Component: ReceivedFeedbacksPage
 */
export const Route = createFileRoute('/_auth/performance/feedbacks/received')({
  component: ReceivedFeedbacksPage,
})
